import axios from 'axios';
import { API_URL } from '../constants/index.js';
import { useInterceptor } from './apiUtils';

useInterceptor(axios);

export function createGroupTourismInterest(data) {
  return axios({
    method: 'post',
    url: `${API_URL}/group_tourism_interests`,
    data: { group_tourism_interest: data }
  });
}

export function getGroupTourismInterests(params) {
  return axios({ method: 'get', url: `${API_URL}/group_tourism_interests`, params: params || {} });
}

export function showGroupTourismInterest(id) {
  return axios({ method: 'get', url: `${API_URL}/group_tourism_interests/${id}` });
}

export function updateGroupTourismInterest(id, data) {
  return axios({
    method: 'put',
    url: `${API_URL}/admin/group_tourism_interests/${id}`,
    data: { group_tourism_interest: data }
  });
}

export function markRestPaidGroupTourism(id, offlinePayment = {}) {
  return axios({
    method: 'put',
    url: `${API_URL}/admin/group_tourism_interests/${id}`,
    data: {
      group_tourism_interest: { status: 'rest_paid' },
      offline_payment: offlinePayment
    }
  });
}

export function sendRestPaymentLink(id) {
  return axios({ method: 'post', url: `${API_URL}/admin/group_tourism_interests/${id}/send_rest_link` });
}

export function getRestPaymentInfo(id) {
  return axios({ method: 'get', url: `${API_URL}/group_tourism_interests/${id}/rest_payment_info` });
}

export function getInterestPaymentInfo(id) {
  return axios({ method: 'get', url: `${API_URL}/group_tourism_interests/${id}/interest_payment_info` });
}

export function initiateRestPayment(id) {
  return axios({ method: 'post', url: `${API_URL}/group_tourism_interests/${id}/initiate_rest_payment` });
}

export function sendInterestLink(id) {
  return axios({ method: 'post', url: `${API_URL}/admin/group_tourism_interests/${id}/send_interest_link` });
}

export function refundGroupTourismInterest(id) {
  return axios({ method: 'post', url: `${API_URL}/admin/group_tourism_interests/${id}/refund` });
}

export function markInterestPaidGroupTourism(id, offlinePayment = {}) {
  return axios({
    method: 'post',
    url: `${API_URL}/admin/group_tourism_interests/${id}/mark_interest_paid`,
    data: { offline_payment: offlinePayment }
  });
}

export function getMyGroupTripInterests() {
  return axios({ method: 'get', url: `${API_URL}/group_tourism_interests/my` });
}

export function updateNumberOfPeople(id, number_of_people) {
  return axios({
    method: 'put',
    url: `${API_URL}/group_tourism_interests/${id}/update_number_of_people`,
    data: { number_of_people }
  });
}

export function cancelGroupTourismInterest(id) {
  return axios({ method: 'patch', url: `${API_URL}/group_tourism_interests/${id}/cancel` });
}
